import React from 'react';
import { PopoverContent, List, BoxProps } from '@stockx/ui';

const Menu = ({ children }: BoxProps) => (
  <PopoverContent
    width="max-content"
    boxShadow={'0 1px 8px 0 rgba(0, 0, 0, 0.15)'}
    borderRadius={0}
    border={0}
  >
    <List spacing={0} sx={{ a: { padding: '0 !important' } }}>
      {children}
    </List>
  </PopoverContent>
);

export default Menu;
